import React, { useEffect, useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import LoadingEllipsis from '../../components/LoadingEllipsis/LoadingEllipsis';
import { AuthContext } from '../../context/auth';
import './styles/ResetPassword.css';
import { useSearchParams } from 'react-router-dom';


import bckgVideo from '../../assets/video/lemons.mp4';
import fallbackVideo from '../../assets/video/water.mp4';
import fallbackImg from '../../assets/img/fallback.webp';
import fallbackMobileImg from '../../assets/img/ban1.webp';

const ResetPassword = () => {
  const { resetPassword } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');


  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const [videoError, setVideoError] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentYear] = useState(new Date().getFullYear());

  const videoRef = useRef();

  const validationSchema = Yup.object({

    newPassword: Yup.string().min(6, 'Mínimo 6 caracteres').required('Obrigatório'),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Senhas não coincidem')
      .required('Obrigatório'),
  });
  useEffect(() => {

    if (!token) {
      setMessage('Link inválido ou expirado.');
    }
  }, [token]);


  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    setMessage('');

    if (!token) {
      setMessage('Token de redefinição ausente ou inválido.');
      setLoading(false);
      return;
    }


    try {
      console.log("envidando valores: ", values);

      const response = await resetPassword(token, values.newPassword, values.confirmNewPassword);
      const successMessage = response?.data?.message || response?.message || 'Senha atualizada com sucesso!';

      if (response?.status === 200 || successMessage.includes('sucesso')) {
        setMessage(successMessage);
        setTimeout(() => navigate('/'), 4000);
      } else {
        setMessage(successMessage || 'Erro ao redefinir a senha.');
      }
    } catch (error) {
      console.error('Erro no resetPassword:', error);
      const errorMsg = error?.response?.data || error?.message || 'Erro ao redefinir a senha.';
      setMessage(typeof errorMsg === 'string' ? errorMsg : 'Erro inesperado.');
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(''), 4000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="resset-container">
      <div className="ressetVideoBox">
        {isMobile ? (
          <img src={fallbackMobileImg} className="loginFallbackImg" alt="Fallback Mobile Image" />
        ) : !videoError ? (
          <video ref={videoRef} muted autoPlay loop onError={() => setVideoError(true)}>
            <source src={bckgVideo} type="video/mp4" onError={() => (videoRef.current.src = fallbackVideo)} />
            <source src={fallbackVideo} type="video/mp4" />
          </video>
        ) : (
          <img src={fallbackImg} className="loginFallbackImg" alt="Fallback Image" />
        )}
      </div>

      <div className="ressetBox">
        <span className="spanReset">Redefinir Senha</span>

        {loading && <div className="message"><LoadingEllipsis message='Aguarde' /></div>}
        {message && <div className="message">{message}</div>}

        <Formik
          initialValues={{
            newPassword: '',
            confirmNewPassword: '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <Form>
            <div className="ressetBoxBlock">
              <label className="form-label">Nova Senha</label>
              <Field type="password" name="newPassword" />
              <ErrorMessage name="newPassword" component="div" className="error-message" />
            </div>

            <div className="ressetBoxBlock">
              <label className="form-label">Confirmar Nova Senha</label>
              <Field type="password" name="confirmNewPassword" />
              <ErrorMessage name="confirmNewPassword" component="div" className="error-message" />
            </div>

            <div className="ressetBtn">
              <button className="form-btn btn" type="submit">
                Redefinir Senha
              </button>
            </div>
            <div className="exitLink">
              <a href="/">sair</a>
            </div>
          </Form>
        </Formik>
      </div>

      <div className="footerLogin">
        <div className="year">2007 - <span>{currentYear}</span></div>
        <div>&copy; todos os direitos reservados</div>
        <div>powered by <span className="brand">apit solutions</span></div>
      </div>
    </div>
  );
};

export default ResetPassword;
